var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFather(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_190982",
    "data-name": "Group 190982",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.282,
    height: 30.638,
    viewBox: "0 0 28.282 30.638",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_176456",
    "data-name": "Group 176456",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173781",
    "data-name": "Path 173781",
    d: "M22.158,17.676A8.838,8.838,0,1,0,13.32,8.838a8.847,8.847,0,0,0,8.838,8.838m0-15.319a6.481,6.481,0,1,1-6.481,6.481,6.489,6.489,0,0,1,6.481-6.481",
    transform: "translate(-8.017)",
    fill: "#f26422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173782",
    "data-name": "Path 173782",
    d: "M21.2,43.271a10.98,10.98,0,0,1-2.283,1.475,11.8,11.8,0,0,1,6.947,9.58H2.416a11.8,11.8,0,0,1,6.947-9.58A10.981,10.981,0,0,1,7.08,43.271,14.138,14.138,0,0,0,0,55.5v1.178H28.282V55.5A14.138,14.138,0,0,0,21.2,43.271",
    transform: "translate(0 -26.045)",
    fill: "#f26422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173783",
    "data-name": "Path 173783",
    d: "M26.132,24.656a3.327,3.327,0,0,1-2.58-1.226,3.324,3.324,0,0,1,5.163,0,3.329,3.329,0,0,1-2.584,1.226",
    transform: "translate(-14.176 -13.362)",
    fill: "#f26422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173784",
    "data-name": "Path 173784",
    d: "M37.1,24.656a3.327,3.327,0,0,1-2.58-1.226,3.324,3.324,0,0,1,5.163,0A3.329,3.329,0,0,1,37.1,24.656",
    transform: "translate(-20.777 -13.362)",
    fill: "#f26422"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFather);
export default __webpack_public_path__ + "static/media/father.eac75b8a20685f30eca4d551f1dc1394.svg";
export { ForwardRef as ReactComponent };